if (!customElements.get('bundle-page')) {
  const renderBuyModal = (product, buy = false) => {
    if (!product) return;
    
    const options = [product.color];
    return `
      <div data-buy-modal="${buy}" class="sp-fixed sp-top-0 sp-left-0 sp-w-full sp-h-full sp-flex sp-items-center sp-justify-center sp-bg-[rgba(0,0,0,0.6)] sp-z-[1001]">
        <div data-buy-modal-content class="[&_p]:sp-my-0 sp-leading-[1.2] sp-font-body sp-flex sp-flex-col sp-gap-4 sp-p-[24px] sp-w-full sp-max-w-[420px] sp-relative sp-text-pakaBlack sp-bg-pakaWhite sp-text-[12px]">
          <button 
            aria-label="Close modal"
            data-action="close-buy-modal"
            class="sp-absolute sp-right-4 sp-top-4 sp-border sp-border-solid sp-rotate-45 sp-bg-transparent sp-border-pakaBlack sp-rounded-full sp-cursor-pointer sp-h-20 sp-w-20 sp-text-3xl hover:sp-bg-pakaBlack hover:sp-text-pakaWhite hover:sp-border-pakaWhite sp-transition sp-duration-200" 
          >
            +
          </button>
          <h2 class="sp-block sp-font-bold tw-text-paka-black sp-my-0 sp-text-[18px] sp-pr-[70px]">${product.title}</h2>
          ${product.details ? `<div class="sp-pr-[40px] sp-pb-[16px]">${product.details}</div>` : ''}
          ${product.options.map((option) => {
            const isColor = option.name.toLowerCase().trim().includes('color');
            return `
              <strong class="${isColor && product.color ? 'hidden' : ''} sp-text-[14px]">Pick your ${option.name}:</strong>
              <ul class="sp-list-style-none sp-flex sp-items-center sp-flex-wrap sp-gap-4 sp-p-0 sp-m-0 ${isColor && product.color ? 'sr-only' : ''}">
                ${option.values.map((value) => {
                  const thisOptions = [value, ...options.filter(x => x)];
                  const availableVariantHasOption = product.variants.find(({ options }) => thisOptions.every((x) => options.find(y => y === x)))?.available;
                  if (isColor) {
                    const swatch = product.swatches[value];
                    return `
                      <div class="tw-flex">
                        <input ${availableVariantHasOption ? '' : 'disabled'} ${value === product.color ? 'checked' : ''} data-action="option-select" type="radio" id="${option.name}-${value}" class="tw-hidden tw-peer sp-peer" name="${option.name}" value="${value}">
                        <label 
                          for="${option.name}-${value}" 
                          class="tw-inline-flex tw-justify-center tw-items-center tw-w-16 tw-h-16 tw-rounded-full tw-cursor-pointer tw-border-0 peer-checked:tw-border-2 tw-border-solid tw-border-paka-black peer-disabled:sp-opacity-50" 
                          style="background-color: ${swatch}" 
                          title="${value}"
                        >
                          <span class="tw-hidden">${value}</span>
                        </label>
                      </div>
                    `;
                  }
                  return `
                    <li class="tw-flex">
                      <input ${availableVariantHasOption ? '' : 'disabled'} data-action="option-select" type="radio" id="${option.name}-${value}" class="tw-hidden tw-peer sp-peer" name="${option.name}" value="${value}">
                      <label for="${option.name}-${value}" class="tw-inline-flex tw-justify-center tw-items-center tw-w-18 tw-h-18 xl:tw-w-20 xl:tw-h-20 tw-rounded-full tw-border-paka-grey tw-text-paka-grey tw-cursor-pointer tw-border tw-border-solid peer-checked:tw-bg-paka-black peer-disabled:sp-opacity-50 peer-checked:tw-border-paka-black peer-checked:tw-text-paka-white">
                        <span class="tw-font-extrabold tw-pt-1">${value}</span>
                      </label>
                    </li>
                  `
                }).join('')}
              </ul>
            `
          }).join('')}
        </div>
      </div>
    `;
  };
    
  const calculateDiscountPercentage = ({ quantity, price }) => {
    if (quantity >= 3) {
      return {
        discountMessage: '30% OFF',
        price: (price * 0.7).toFixed(2)
      };
    }
    // ---Just in case
    // if (quantity >= 12) {
    //   return {
    //     discountMessage: '30% OFF',
    //     price: (price * 0.7).toFixed(2)
    //   };
    // } else if (quantity >= 6) {
    //   return {
    //     discountMessage: '20% OFF',
    //     price: (price * 0.8).toFixed(2)
    //   }
    // } else if (quantity >= 3) {
    //   return {
    //     discountMessage: '10% OFF',
    //     price: (price * 0.9).toFixed(2)
    //   }
    // }
  }
  
  const renderStickyBottomBar = (selectedVariants, mascot) => {
    const bundleQuantity = Object.keys(selectedVariants).reduce((accumulator, currentValue) => accumulator + selectedVariants[currentValue].quantity, 0);
    const price = Object.keys(selectedVariants).reduce((accumulator, currentValue) => accumulator + (selectedVariants[currentValue].price * selectedVariants[currentValue].quantity), 0);

    return `
      <div class="sticky-bottom-bar sp-overflow-auto sp-flex-grow sp-bg-pakaWhite sp-border-solid sp-border-2 sp-border-pakaBlack md:sp-px-16 md:sp-pb-16">
        <div class="sp-sticky sp-z-1 sp-top-0 sp-bg-pakaWhite sp-px-16 max-md:sp-py-4">
          <button data-action="expand-bundle" class="sp-w-full sp-bg-transparent sp-border-0 sp-flex sp-justify-center sp-items-center sp-gap-4 sp-px-0">
            <span class="sp-font-bold sp-underline sp-text-2xl md:sp-hidden">See Your Bundle (${bundleQuantity})</span>
            <span class="sp-flex sp-items-center sp-justify-center sp-w-[28px] sp-h-[28px] sp-p-[2px]">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="9" viewBox="0 0 14 9" fill="none">
                <path d="M2.04802e-08 7.28257L1.65085 9L7 3.43492L12.3491 9L14 7.28257L7 8.34742e-08L2.04802e-08 7.28257Z" fill="#212329"/>
              </svg>
            </span>
          </button>
          <button data-action="collapse-bundle" class="sp-w-full sp-bg-transparent sp-border-0 sp-flex sp-justify-center sp-items-center sp-gap-4 sp-px-0">
            <span class="sp-font-bold sp-underline sp-text-2xl md:sp-hidden">Hide Your Bundle (${bundleQuantity})</span>
            <span class="sp-transform sp-rotate-180 sp-flex sp-items-center sp-justify-center sp-w-[28px] sp-h-[28px] sp-p-[2px]">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="9" viewBox="0 0 14 9" fill="none">
                <path d="M2.04802e-08 7.28257L1.65085 9L7 3.43492L12.3491 9L14 7.28257L7 8.34742e-08L2.04802e-08 7.28257Z" fill="#212329"/>
              </svg>
            </span>
          </button>
        </div>
        
        <div class="desktop-closed-drawer-content sp-hidden sp-justify-center sp-py-4 md:sp-flex sp-gap-4 max-md:sp-pt-4 md:sp-gap-12 sp-min-w-max">
          <span class="sp-items-center sp-flex sp-gap-4 max-md:sp-justify-center">
            ${bundleQuantity >= 12 ? `
              <span class="sp-flex sp-items-center sp-px-6 sp-leading-[12px] sp-h-max sp-w-max sp-text-[12px] sp-py-2 sp-rounded-full sp-text-pakaWhite sp-bg-[#527162] sp-font-bold">${calculateDiscountPercentage({ quantity: bundleQuantity, price: (price / 100).toFixed(2) }).discountMessage}</span>
            ` : ''}
            ${bundleQuantity >= 12 ? `<span class="sp-line-through">$${(price / 100).toFixed(2)}</span>` : ''}
            <span class="sp-font-bold">$${bundleQuantity >= 3 ? calculateDiscountPercentage({ quantity: bundleQuantity, price: (price / 100).toFixed(2) }).price : (price / 100).toFixed(2)}</span>
          </span>
          <button data-action="add-bundle-to-cart" class="button button-primary !sp-text-pakaWhite sp-font-bold max-md:sp-py-9">ADD BUNDLE TO CART</button>
        </div>
        
        <div class="sp-flex sp-gap-4 md:sp-items-center md:sp-gap-16 max-md:sp-flex-col md:sp-overflow-hidden md:sp-max-h-[--bundle-content-height]">
          <div class="sp-flex sp-flex-col max-md:sp-w-full max-md:sp-leading-none sp-min-w-max max-md:sp-hidden max-md:sp-px-16">
            <strong class="sp-block sp-pb-5 max-md:text-3xl sp-text-5xl tw-font-bold tw-text-paka-black tw-tracking-tight">Build Your Bundle</strong>
            <span>Buy 3 Save 10%, Buy 6 Save 20%, Buy 12 Save 30%</span>
          </div>
          <div data-product-wrap class="sp-grid sp-grid-cols-3 md:sp-flex md:sp-overflow-auto [&>div]:md:sp-max-w-[calc((100%/6.5)-2rem)] [&>div]:md:w-full [&>div]:md:sp-min-w-[100px] sp-gap-8 max-md:sp-px-16 max-md:sp-overflow-hidden max-md:sp-max-h-[--bundle-content-height]">
            ${mascot ? `
              <div class="max-md:sp-order-3 sp-scale-110 md:sp-hidden sp-transform sp-aspect-[3/5]">
                ${mascot}
              </div>
            ` : ''}
            ${Object.keys(selectedVariants).reverse().map((key, i) => {
              const variant = selectedVariants[key];
              return `
                <div style="order: ${i + 1}" class="sp-flex sp-flex-col sp-h-full sp-justify-between sp-relative sp-pt-4">
                  <img width="150" class="sp-block  sp-h-auto sp-object-center sp-object-contain sp-aspect-[4/5]" alt="${variant.featured_image.alt}" src="${variant.featured_image.src}" />
                  <small class="sp-text-[10px]">
                    <strong class="sp-leading-none">${variant.options.join('/')} (${variant.quantity})</strong>
                    &nbsp;
                    <span class="sp-leading-none">$${((variant.price * variant.quantity) / 100).toFixed(2)}</span>
                  </small>
                  <div class="sp-flex sp-items-center sp-gap-4 sp-w-full sp-pt-4">
                    <button 
                      data-action="remove-variant" 
                      data-variant="${variant.id}" 
                      class="sp-text-[0] sp-flex sp-items-center sp-justify-center sp-border sp-border-solid sp-border-pakaBlack sp-rounded-full sp-cursor-pointer sp-max-w-[25px] sp-max-h-[25px] sp-min-w-[25px] sp-min-h-[25px] sp-aspect-square sp-text-3xl hover:sp-bg-pakaBlack hover:sp-text-pakaWhite hover:sp-border-pakaWhite sp-transition sp-duration-200 sp-absolute sp-top-0 sp-right-0 sp-transform sp-bg-pakaWhite sp-translate-x-1/3"
                    >
                      <span class="sp-text-[14px] sp-transform sp-rotate-45 sp-block sp-leading-none">+</span>
                    </button>
                  </div>
                </div>
              `
            }).join('')}
          </div>
          ${mascot ? `
            <div class="md:sp-max-w-[125px] md:sp-min-w-[125px] sp-w-[125px] sp-hidden md:sp-block sp-transform sp-aspect-[4/5] -sp-translate-y-6">
              ${mascot}
            </div>
          ` : ''}
          <div class="sp-flex sp-flex-col sp-gap-4 max-md:sp-pt-4 md:sp-gap-12 sp-min-w-max max-md:sp-order-last max-md:sp-bg-pakaWhite max-md:sp-sticky max-md:sp-bottom-0">
            <span class="sp-items-center sp-flex sp-gap-4 max-md:sp-justify-center">
              ${bundleQuantity >= 12 ? `
                <span class="sp-flex sp-items-center sp-px-6 sp-leading-[12px] sp-h-max sp-w-max sp-text-[12px] sp-py-2 sp-rounded-full sp-text-pakaWhite sp-bg-[#527162] sp-font-bold">${calculateDiscountPercentage({ quantity: bundleQuantity, price: (price / 100).toFixed(2) }).discountMessage}</span>
              ` : ''}
              ${bundleQuantity >= 12 ? `<span class="sp-line-through">$${(price / 100).toFixed(2)}</span>` : ''}
              <span class="sp-font-bold">$${bundleQuantity >= 12 ? calculateDiscountPercentage({ quantity: bundleQuantity, price: (price / 100).toFixed(2) }).price : (price / 100).toFixed(2)}</span>
            </span>
            <span class="sp-block md:sp-hidden sp-italic sp-opacity-70 sp-text-center">See Cart For Discount</span>
            <button data-action="add-bundle-to-cart" class="button button-primary !sp-text-pakaWhite sp-font-bold max-md:sp-py-9">ADD BUNDLE TO CART</button>
            <span class="sp-hidden md:sp-block sp-italic sp-opacity-70">See Cart For Discount</span>
          </div>
        </div>
      </div>
    `;
  }
  
  class BundlePage extends HTMLElement {
    constructor() {
      super();
      this.selectedVariants = [];
      this.selectedProduct = null;
      this.selectionModalOpen = false;
      this.mascot = false;
    }
    
    connectedCallback() {
      this.mascot = this.querySelector('template[data-mascot-image]')?.innerHTML;

      this.addEventListener('click', e => {
        if (this.selectionModalOpen && !e.target.closest('[data-buy-modal-content]')) {
          this.querySelector('[data-buy-modal]')?.remove();
          this.selectedProduct = null;
          this.selectionModalOpen = false;
        }
        
        const clickedElement = e.target.closest('[data-action]');
        if (!clickedElement) return;
        
        const { 
          action,
          product,
          variant
        } = clickedElement.dataset;
      
        switch(action) {
          case 'expand-bundle': 
            this.style.setProperty('--bundle-content-height', `${this.querySelector('[data-product-wrap]')?.scrollHeight ?? 0}px`);

            this.classList.add('bundle-open');
          break;
          case 'collapse-bundle': 
            this.style.setProperty('--bundle-content-height', `0px`);
            this.classList.remove('bundle-open');
          break;
          case 'remove-variant':
            delete this.selectedVariants[variant];
            
            if (!Object.keys(this.selectedVariants).length) {
              this.querySelector('[data-sticky-bottom-bar]').innerHTML = '';
              return;
            }
            
            this.querySelector('[data-sticky-bottom-bar]').innerHTML = renderStickyBottomBar(this.selectedVariants, this.mascot);
            this.style.setProperty('--bundle-content-height', `${this.querySelector('[data-product-wrap]')?.scrollHeight ?? 0}px`);
          break;
          case 'option-select':
            const thisOptions = [...this.querySelectorAll('[data-action="option-select"]:checked')].map(x => x.value);
            const matchingVariant = this.selectedProduct.variants.find((variant) => variant.options.every(x => thisOptions.find(y => y === x)));
            if (!matchingVariant) {
              this.checkAvailabilityOfSizes();
              return;
            }
            
            if (!clickedElement.closest('[data-buy-modal="true"')) {
              this.selectedVariants[matchingVariant.id] = {
                quantity: this.selectedVariants[matchingVariant.id]?.quantity ? this.selectedVariants[matchingVariant.id].quantity + 1 : 1,
                ... matchingVariant
              };
              this.querySelector('[data-buy-modal]')?.remove();
              this.querySelector('[data-sticky-bottom-bar]').innerHTML = renderStickyBottomBar(this.selectedVariants, this.mascot);
              
              if (window.matchMedia('(max-width: 768px)').matches) return;
              this.style.setProperty('--bundle-content-height', `${this.querySelector('[data-product-wrap]')?.scrollHeight ?? 0}px`);
              this.classList.add('bundle-open');
              return;
            }
            
            this.addToCart({
              quantity: 1,
              id: matchingVariant.id
            });
          break;
          case 'add-bundle-to-cart':
            this.addToCart({
              items: Object.keys(this.selectedVariants).map((key) => {
                const { id, quantity } = this.selectedVariants[key];
                return ({ 
                  id, 
                  quantity,
                  properties: { "_bundleItem": true }
                })
              })
            });
          break;
          case 'open-buy-modal':
            this.insertAdjacentHTML('beforeend', renderBuyModal(JSON.parse(product), true));
            this.selectedProduct = JSON.parse(product);
            this.selectionModalOpen = true;
            if (window.matchMedia('(min-width: 768px)').matches) return;
            this.style.setProperty('--bundle-content-height', `0px`);
            this.classList.remove('bundle-open');
          break;
          case 'open-bundle-modal':
            this.insertAdjacentHTML('beforeend', renderBuyModal(JSON.parse(product)));
            this.selectedProduct = JSON.parse(product);
            this.selectionModalOpen = true;
            
            if (window.matchMedia('(min-width: 768px)').matches) return;
            this.style.setProperty('--bundle-content-height', `0px`);
            this.classList.remove('bundle-open');
          break;
          case 'close-buy-modal':
            this.querySelector('[data-buy-modal]')?.remove();
            this.selectedProduct = null;
            this.selectionModalOpen = false;
          break;
          default: break;
        }
      })
    }
    
    checkAvailabilityOfSizes() {
      const thisOptions = [...this.querySelectorAll('[data-action="option-select"]:checked')].map(x => x.value);
      const matchingVariants = this.selectedProduct.variants.filter((variant) => {
        return variant.options.some((option) => thisOptions.find((x) => x === option)) && variant.available;
      });
      const productSizes = this.selectedProduct.options.find((x) => x.name.toLowerCase().trim().includes('size'))?.values;
      const availableVariantSizes = matchingVariants.map(({ options }) => options.filter(x => productSizes.find(y => y === x))).flat();
      
      this.querySelectorAll('[data-action="option-select"]').forEach((selectEl) => {
        if (!productSizes.find(x => x === selectEl.value)) return;
        
        if (availableVariantSizes.find(x => x === selectEl.value)) {
          selectEl.removeAttribute('disabled');
          return;
        }
        
        selectEl.setAttribute('disabled', true);
      });
    }
    
    async addToCart(data) {
      const cart = document.querySelector('mini-cart')
      await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
        }).then(() => {
          cart.getCart();
          this.querySelector('[data-buy-modal]')?.remove();
        })
        .finally(() => document.dispatchEvent(new Event('cart:updated')))
        .catch((error) => {
          console.error('Error:', error);
        });   
    }
  }

  customElements.define('bundle-page', BundlePage);
}